import IntlMessages from 'util/IntlMessages';

import styles from './styles.module.less';

export default function LogoutButton({ onSignOut, collapsed = false }) {
  return (
    <div className={styles.logoutButtonContainer} onClick={onSignOut}>
      <div className="gx-flex-row gx-justify-content-center">
        <span className="material-symbols-outlined">logout</span>
      </div>
      {!collapsed && (
        <div className="gx-flex-row gx-justify-content-center">
          <IntlMessages id="sidebar.extensions.logout" />
        </div>
      )}
    </div>
  );
}
